<template>
    <div class="tabs-progress">
        <template v-for="(step, index) in steps" :key="step.key">
            <div v-if="index > 0" class="tabs-progress__separator" />
            <button
                type="button"
                class="tabs-progress__step"
                :class="{
                    'tabs-progress__step--current': step.key === currentStep,
                    'tabs-progress__step--completed': isCompleted(step.key) && step.key !== currentStep,
                    'tabs-progress__step--pending': step.key !== currentStep && !isCompleted(step.key),
                }"
                :disabled="!resolvedCanGoToStep(step.key)"
                @click="resolvedCanGoToStep(step.key) && emit('update:currentStep', step.key)"
            >
                <span
                    class="tabs-progress__badge"
                    :class="{
                        'tabs-progress__badge--current': step.key === currentStep,
                        'tabs-progress__badge--completed': isCompleted(step.key) && step.key !== currentStep,
                        'tabs-progress__badge--pending': step.key !== currentStep && !isCompleted(step.key),
                    }"
                >
                    <Icon
                        v-if="isCompleted(step.key) && step.key !== currentStep"
                        icon="hero/solid/check"
                        class="w-3 h-3"
                    />
                    <span v-else>{{ index + 1 }}</span>
                </span>
                {{ step.label }}
            </button>
        </template>
    </div>
</template>

<script setup lang="ts">
interface Step {
    key: string;
    label: string;
}

interface Props {
    steps: Step[];
    currentStep: string;
    completedSteps: string[];
    canGoToStep?: (key: string) => boolean;
}

const props = withDefaults(defineProps<Props>(), {
    canGoToStep: undefined,
});

const emit = defineEmits<{
    'update:currentStep': [key: string];
}>();

function isCompleted(key: string): boolean {
    return props.completedSteps.includes(key);
}

function resolvedCanGoToStep(key: string): boolean {
    if (props.canGoToStep) return props.canGoToStep(key);
    return true;
}
</script>
